import { ApiError, fieldErrorsOf } from '@/api/client';
import { blockersOf } from './environmentHelpers';
import { failureOutcome, type FailureInfo, type FailureOutcome, type FieldErrors } from './environmentFormModel';

/** What the form reads off an API problem; `null` for any other error. Needs `ApiError`, so it stays out of the model. */
export function describeFailure(err: unknown): FailureInfo | null {
  if (!(err instanceof ApiError)) return null;
  return { status: err.status, code: err.code, message: err.message, toastTitle: err.toastTitle, fieldErrors: fieldErrorsOf(err) as FieldErrors, blockers: blockersOf(err) };
}

/** What a form shows after a failed create or save. */
export interface FailureEffect {
  server?: FieldErrors;
  /** `undefined` = leave the problem alert as it is. */
  problem?: unknown;
  toast?: { title: string; description?: string };
}

/** Applies the model's decision to the actual error: the problem alert is the error itself, a plain `Error` or a 412 that keeps the request id. */
export function failureEffectOf(err: unknown, slugChanged: boolean): FailureEffect {
  const outcome: FailureOutcome = failureOutcome(describeFailure(err), slugChanged);
  const { problem } = outcome;
  if (!problem) return { server: outcome.server, toast: outcome.toast };
  if (problem.kind === 'same') return { problem: err };
  if (problem.kind === 'message') return { problem: new Error(problem.message) };
  const api = err as ApiError;
  return { problem: new ApiError(412, api.code, problem.message, api.requestId) };
}
